export default __webpack_public_path__ + "static/media/marketing.d77c737d.svg";